// extracted by mini-css-extract-plugin
export default {"serverErrorTextArea":"PortalServerErrorNotification__serverErrorTextArea__sBLMB"};